// extracted by mini-css-extract-plugin
export default {"col_w1000":"index_col_w1000_rJaKL","menu_100":"index_menu_100_v1r2k","menu_1000":"index_menu_1000_-lNIC","space26":"index_space26_DZGHe"};